module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-banner-2-6bd9076edc0374e394af726316eb0507.jpg";